/**
 * Escape text for safe interpolation into HTML.
 * @param {unknown} value
 * @returns {string}
 */
export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/**
 * Return the first non-empty string among values, or the first nested
 * message/detail/error/reason/description string found on objects.
 * @param {...unknown} values
 * @returns {string}
 */
export function pickFirstTextValue(...values) {
  const textFromObject = (value) => {
    if (!value || typeof value !== "object") return "";
    const candidates = [value.message, value.detail, value.error, value.reason, value.description];
    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim()) {
        return candidate.trim();
      }
    }
    return "";
  };

  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
    const extracted = textFromObject(value);
    if (extracted) return extracted;
  }
  return "";
}
